<template>
  <div class="weeklyMenu" ref="box">
    <van-tabs
      v-model="activeName"
      type="line"
      background="#FFD63C"
      color="#000"
      style="position: fixed; top: 0; left: 0; right: 0;z-index: 15;"
      @change="handleChange"
      @disabled="handleDisabled"
    >
      <van-tab
        v-for="item in canteenList"
        :key="item.id"
        :title="item.name"
        :name="item.id"
      ></van-tab>
      <!-- :disabled="item.id === '310101002003'" -->
    </van-tabs>

    <div class="main-content">
      <div class="introduce">
        <div class="title">
          <img src="@/assets/images/Group5.png" alt />
          <span>食堂介绍</span>
          <img src="@/assets/images/Group6.png" alt />
        </div>
        <div class="text">
          <div class="text-all">
            {{ activeCanteen.introduction }}
            <br />电话：{{ activeCanteen.phone }} <br />地址：{{
              activeCanteen.address
            }}
          </div>
        </div>
        <div class="icon-info">
          <div class="info-addr" @click="handleComeHereClick">
            <img src="@/assets/images/addr-new.png" alt="" />
            去这里
          </div>
          <a :href="`tel:${activeCanteen.phone}`">
            <img src="@/assets/images/phone-new.png" alt="" />
            打电话
          </a>
        </div>
      </div>
      <div class="tabs" ref="tabsRef">
        <div
          v-for="(item, index) in menu.weeks"
          :key="index"
          class="tabItem"
          :id="'b' + index"
          :class="active == index ? 'active' : ''"
          style="margin-left:10px"
          @click="goAnchor('a' + index, index)"
        >
          {{ item.week }}
        </div>
      </div>
      <div class="foodList" ref="foodList">
        <div v-if="loading" style="text-align: center;margin-top: 30px;">
          <van-loading type="spinner" />
        </div>
        <div v-else class="foodList-bg" ref="foodListBg">
          <div
            v-if="!menu.weeks"
            style="text-align: center;margin-top: 30px; color: #999;font-size: 18px;"
          >
            暂无数据...
          </div>
          <template v-else>
            <div
              v-for="(item, index) in menu.weeks"
              :key="index"
              style="padding:0 12px;box-sizing: border-box;"
              :id="'a' + index"
            >
              <div
                style="color: #333;font-size: 18px;font-weight: 500;height:42px;line-height:42px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
              >
                {{ item.time }}
              </div>
              <div
                v-if="item.big.length"
                style="height: 172px;padding:0 10px;box-sizing: border-box;"
                class="menubg"
              >
                <div
                  style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
                >
                  大荤
                </div>

                <div class="scroll">
                  <div
                    class="scrollItemBox"
                    v-for="(item, index) in item.big"
                    :key="index"
                  >
                    <div class="scrollItem">
                      <img
                        v-if="item.foodImgPaths && item.foodImgPaths[0]"
                        style="width:100%;height:100%;"
                        :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                      />
                      <img
                        v-else
                        style="width:100%;height:100%;"
                        src="../../assets/images/caipin_empty.png"
                      />
                    </div>
                    <div
                      style="margin:6px 0 4px; font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                      class="ellipsis"
                    >
                      {{ item.dishName }}
                    </div>
                    <div
                      style="color:#F04242; font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    >
                      {{ item.dishPrice }}元
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="item.small.length"
                style="height: 172px;padding:0 10px;box-sizing: border-box;"
                class="menubg1"
              >
                <div
                  style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
                >
                  小荤
                </div>

                <div class="scroll">
                  <div
                    class="scrollItemBox"
                    v-for="(item, index) in item.small"
                    :key="index"
                  >
                    <div class="scrollItem">
                      <img
                        v-if="item.foodImgPaths && item.foodImgPaths[0]"
                        style="width:100%;height:100%;"
                        :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                      />
                      <img
                        v-else
                        style="width:100%;height:100%;"
                        src="../../assets/images/caipin_empty.png"
                      />
                    </div>
                    <div
                      style="margin:6px 0 4px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                      class="ellipsis"
                    >
                      {{ item.dishName }}
                    </div>
                    <div
                      style="color:#F04242;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    >
                      {{ item.dishPrice }}元
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="item.veg.length"
                style="height: 172px;padding:0 10px;box-sizing: border-box;"
                class="menubg2"
              >
                <div
                  style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
                >
                  素菜
                </div>

                <div class="scroll">
                  <div
                    class="scrollItemBox"
                    v-for="(item, index) in item.veg"
                    :key="index"
                  >
                    <div class="scrollItem">
                      <img
                        v-if="item.foodImgPaths && item.foodImgPaths[0]"
                        style="width:100%;height:100%;"
                        :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                      />
                      <img
                        v-else
                        style="width:100%;height:100%;"
                        src="../../assets/images/caipin_empty.png"
                      />
                    </div>
                    <div
                      style="margin:6px 0 4px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                      class="ellipsis"
                    >
                      {{ item.dishName }}
                    </div>
                    <div
                      style="color:#F04242;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    >
                      {{ item.dishPrice }}元
                    </div>
                  </div>
                </div>
              </div>

              <div
                style="height:42px;line-height:42px;display:flex;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div style="font-size: 16px;font-weight: 500;">长者套餐</div>
                <div style="color: #8F8F8F;font-size: 12px;">
                  社区65岁及以上人群专享
                </div>
              </div>
              <!-- 套餐 -->
              <template>
                <div
                  v-for="(item, index) in menu.grops"
                  :key="item.id"
                  style="height:34px;line-height:42px;display:flex;align-items:
                  center;justify-content: space-between;padding:0
                  13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐{{ index + 1 }}</div>
                    <span style="font-size: 14px;margin-left:10px">{{
                      item.label
                    }}</span>
                  </div>
                  <div
                    v-if="
                      item.value === 'twoMeatTwoVegetables' &&
                        menu.twoMeatTwoVegetables
                    "
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.twoMeatTwoVegetables }}元
                  </div>
                  <div
                    v-if="
                      item.value === 'oneMeatTwoMeatVegetable' &&
                        menu.oneMeatTwoMeatVegetable
                    "
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.oneMeatTwoMeatVegetable }}元
                  </div>
                  <div
                    v-if="
                      item.value === 'fewMeatVegetables' &&
                        menu.fewMeatVegetables
                    "
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.fewMeatVegetables }}元
                  </div>
                  <div
                    v-if="
                      item.value === 'littleMeatVegetable' &&
                        menu.littleMeatVegetable
                    "
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.littleMeatVegetable }}元
                  </div>
                  <div
                    v-if="item.value === 'vegetable' && menu.vegetable"
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.vegetable }}元
                  </div>
                </div>

                <!-- <div
                  v-if="menu.twoMeatTwoVegetables"
                  style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐1</div>
                    <span style="font-size: 14px;margin-left:10px"
                      >两大荤两素</span
                    >
                  </div>
                  <div
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.twoMeatTwoVegetables }}元
                  </div>
                </div>
                <div
                  style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐1</div>
                    <span style="font-size: 14px;margin-left:10px"
                      >一大荤两小荤一素</span
                    >
                  </div>
                  <div
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.oneMeatTwoMeatVegetable }}元
                  </div>
                </div>
                <div
                  v-if="menu.fewMeatVegetables"
                  style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐2</div>
                    <span style="font-size: 14px;margin-left:10px"
                      >一大荤一小荤两素</span
                    >
                  </div>
                  <div
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.fewMeatVegetables }}元
                  </div>
                </div>
                <div
                  v-if="menu.littleMeatVegetable"
                  style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐3</div>
                    <span style="font-size: 14px;margin-left:10px"
                      >一大荤一小荤一素</span
                    >
                  </div>
                  <div
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.littleMeatVegetable }}元
                  </div>
                </div>
                <div
                  v-if="menu.vegetable"
                  style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
                >
                  <div
                    style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                  >
                    <div class="tag">套餐4</div>
                    <span style="font-size: 14px;margin-left:10px"
                      >一小荤一素</span
                    >
                  </div>
                  <div
                    style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ menu.vegetable }}元
                  </div>
                </div> -->
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 固定定位--背景图等 -->
    <div class="flex flexBg1">
      <img src="@/assets/images/food5.png" alt />
    </div>
    <div class="flex flexBg2">
      <img src="@/assets/images/food2.png" alt />
    </div>
    <div class="flex flexBg3">
      <img src="@/assets/images/food3.png" alt />
    </div>
    <div class="flex flexBg4">
      <img src="@/assets/images/food4.png" alt />
    </div>
    <div class="flex flexBg5">
      <img src="@/assets/images/food5.png" alt />
    </div>
    <div class="flex flexBg6">
      <img src="@/assets/images/food6.png" alt />
    </div>

    <div class="flex history" style="z-index:999;" @click="goPastMeun">
      <img src="@/assets/images/Frame.png" style="width:18px;height:18px" alt />
      往期菜单
    </div>
  </div>
</template>

<script>
import { selectMenuList, foodMenuManage } from '@/api/weeklyMenu';
import { getDatas } from '@/api/user.js';
import { areaCode } from '@/common/constants.js';
import wx from 'weixin-js-sdk';
export default {
  name: 'User',
  data() {
    return {
      isClick: false,
      active: 0,
      currentTime: '',
      menu: {},

      activeName: '310101002001',
      activeCanteen: {},
      canteenList: [
        {
          name: '苏河之眸',
          id: '310101002001',
          introduction:
            '	食堂关注全龄段服务对象，不仅满足大众需求，同时兼顾个性饮食。食堂将提供多种套餐，如适合老上海人的“上海老味道”套餐、适合白领的“健康低卡低脂”套餐、以及专为周边60岁以上长者提供“适老化餐饮”。',
          phone: '021-63509803',
          address: '南京东路街道西藏中路725弄50号为老服务中心2F',
          OrgDetail: {
            latitude: '31.239015', //维度
            longitude: '121.471658', //经度
            orgName: '苏河之眸',
            addr: '上海市黄浦区南京东路街道西藏中路725弄50号',
          },
        },
        {
          name: '爱以德',
          id: '310101002002',
          introduction:
            '	南京东路街道爱以德养老院社区长者食堂，就餐区域宽敞舒适，氛围明亮温馨，特设适老专座和轮椅区，方便长者就餐。餐食营养丰富，针对长者口味精心烹制，并可根据季节和需求提供特殊饮食（忌口、流质）及小锅菜预订服务，确保长者吃得健康、放心、满意。',
          phone: '021-63608866',
          address: '上海市黄浦区广东路525号2楼',
          OrgDetail: {
            latitude: '31.231831', //维度
            longitude: '121.481727', //经度
            orgName: '爱以德',
            addr: '上海市黄浦区广东路525号',
          },
        },
        {
          name: '南东咖堂间',
          id: '310101002003',
          introduction:
            '就餐区域宽敞舒适，就餐空间宽敞明亮，氛围温馨舒适，并设有适老专座和桌边设有拐杖存放处，方便长者就餐。餐食营养丰富，种类多样化，针对长者健康饮食（少油.少糖.少盐），并可根据季节和需求提供特殊饮食，确保长者吃得安全健康、放心、满意。',
          phone: '13658623705',
          address: '上海市黄浦区重庆北路180号3楼',
          OrgDetail: {
            latitude: '31.23', //维度
            longitude: '121.47', //经度
            orgName: '南东咖堂间',
            addr: '上海市黄浦区重庆北路180号3楼',
          },
        },
      ],
      menuList: [
        {
          id: 1,
          label: '两大荤两素',
          value: 'twoMeatTwoVegetables',
        },
        {
          id: 2,
          label: '一大荤两小荤一素',
          value: 'oneMeatTwoMeatVegetable',
        },
        {
          id: 3,
          label: '一大荤一小荤两素',
          value: 'fewMeatVegetables',
        },
        {
          id: 4,
          label: '一大荤一小荤一素',
          value: 'littleMeatVegetable',
        },
        {
          id: 5,
          label: '一小荤一素',
          value: 'vegetable',
        },
      ],
      loading: false,
    };
  },
  watch: {
    active(newVal) {
      this.$nextTick(() => {
        this.setCentert();
      });
    },
  },
  computed: {
    imgUrl() {
      return function(url) {
        if (!url) return '';
        return `${process.env.VUE_APP_API_IMGURL}` + url;
      };
    },
  },
  methods: {
    async handleChange() {
      this.activeCanteen = this.canteenList.find(
        (item) => item.id === this.activeName,
      );
      await this.getData();
    },

    handleDisabled() {
      // 310101002003 是 社区食堂,暂未开业
      this.$toast('筹备中，敬请期待...');
    },
    setCentert() {
      // 外层整个tab
      let tabsRef = this.$refs.tabsRef;
      // 单个tab
      let activeNode = document.querySelector('.tabItem.active');
      // 元素距离滑块左边距离  -  居中时元素到窗口左边距离  =  滚动条滑动的距离
      let scrollWidth =
        activeNode.offsetLeft -
        (tabsRef.clientWidth - activeNode.clientWidth) / 2;
      tabsRef.scrollLeft = scrollWidth;
    },
    goAnchor(selector, index) {
      this.active = index;
      this.isClick = true;
      setTimeout(() => {
        var el = document.getElementById(selector);
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    },
    handleScroll(e) {
      console.log(e);
      if (this.isClick) return;
      //获取dom滚动距离
      const scrollTop = this.$refs.foodListBg.scrollTop;
      //获取可视区高度
      const offsetHeight = this.$refs.foodListBg.offsetHeight;
      //获取滚动条总高度
      const scrollHeight = this.$refs.foodListBg.scrollHeight;

      //xqConList 为目录内容列表
      for (let i = 0; i < 10; i++) {
        //offsetTop: 获取当前元素到其定位父级（offsetParent）的顶部距离
        let offset_before = this.$el.querySelector('#a' + i).offsetTop;
        let offset_after =
          this.$el.querySelector('#a' + i).offsetHeight + offset_before;
        //根据xqItem离顶部距离判断滚动距离落在哪两个item之间
        if (scrollTop >= offset_before && scrollTop < offset_after) {
          if (scrollTop + offsetHeight >= scrollHeight) {
            // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
            // console.log("已滚动到底部");
            if (this.active < i) {
              this.active = i;
            }
          } else {
            this.active = i;
          }
          break;
        }
      }
    },
    getData() {
      this.loading = true;
      foodMenuManage({ area: this.activeName }).then((res) => {
        if (res.code === 0) {
          const weekDays = [
            '周日',
            '周一',
            '周二',
            '周三',
            '周四',
            '周五',
            '周六',
          ];
          if (!res.data.list.length) {
            this.menu = {};
            this.active = 0;
            this.loading = false;
            return;
          }
          let menu = res.data.list[0];
          const arr = [];
          //套餐grops start
          console.log('menu', menu);
          // twoMeatTwoVegetables、oneMeatTwoMeatVegetable、fewMeatVegetables、littleMeatVegetable、vegetable

          this.menuList.forEach((item) => {
            if (menu[item.value]) {
              arr.push({
                label: item.label,
                value: item.value,
                price: menu[item.value],
              });
            }
          });
          menu.grops = arr;

          console.log('arr', arr);
          //套餐grops end

          let weeks = Object.keys(menu.dishesByDate)
            .sort(function(a, b) {
              return (
                new Date(a.replace(/-/g, '/')).getTime() -
                new Date(b.replace(/-/g, '/')).getTime()
              ); //升序排序
            })
            .map((i) => {
              return {
                time: i,
                week: weekDays[new Date(i.replace(/-/g, '/')).getDay()],
                big: menu.dishesByDate[i].filter(
                  (item) => item.dishTypeName == '大荤',
                ),
                small: menu.dishesByDate[i].filter(
                  (item) => item.dishTypeName == '小荤',
                ),
                veg: menu.dishesByDate[i].filter(
                  (item) => item.dishTypeName == '素菜',
                ),
              };
            });
          menu.weeks = weeks;
          this.menu = menu;
          let weekStr = weekDays[new Date().getDay()];
          let num = weeks.findIndex((i) => i.week == weekStr);
          this.active = num == -1 ? 0 : num;
          this.loading = false;

          if (this.active !== 0) {
            this.goAnchor('a' + this.active, this.active);
          }
          console.log(menu);
        }
      });
    },
    // 打开往期菜单
    goPastMeun() {
      this.$router.push(
        `/pastMenu?canteenId=${this.activeName}&canteenName=${this.activeCanteen.name}`,
      );
    },

    // 使用微信定位功能
    async config() {
      const thisPageUrl = location.href.split('#')[0];
      const json = {
        url: thisPageUrl,
      };
      const res = await getDatas({
        url: json.url,
        areaCode,
      });
      wx.config({
        debug: false, // 开启调试模式
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, //生成签名的随机串
        signature: res.signature, //签名
        jsApiList: ['openLocation', 'getLocation'], // 必填，需要使用的JS接口列表
      });
    },
    // 点击调用微信定位事件
    handleComeHereClick() {
      wx.openLocation({
        latitude: parseFloat(this.activeCanteen.OrgDetail.latitude), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(this.activeCanteen.OrgDetail.longitude), // 经度，浮点数，范围为180 ~ -180。
        name: this.activeCanteen.OrgDetail.orgName, // 位置名
        address: this.activeCanteen.OrgDetail.addr, // 地址详情说明
        scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
        success: () => console.log('打开地图成功'),
        fail: (err) => console.log('打开地图失败', err),
      });
    },
  },

  async mounted() {
    const that = this;

    this.config();
    window.document.title = '每周菜单';
    await this.handleChange();
    this.$nextTick(() => {
      this.$refs.foodListBg.addEventListener('scroll', this.handleScroll);
      this.$refs.foodListBg.addEventListener('touchstart', function() {
        that.isClick = false;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.weeklyMenu {
  font-family: 'Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif';
  width: 100vw;
  height: 100vh;
  background: #ffd63c;
  position: absolute;
  left: 0;
  top: 0;

  /* Vue 中使用 scoped 时 */
  ::v-deep .van-tab__text {
    font-size: 18px;
    font-weight: 600;
  }

  .main-content {
    position: relative;
    top: 35px;

    .introduce {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 335px;
      height: 160px;
      background: linear-gradient(180deg, #ffffff 0%, #fff6d6 100%);
      border: 1px solid #ffffff;
      border-radius: 8px;
      z-index: 9;

      .title {
        margin: 13px auto;
        width: 135px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          text-align: center;
          color: #a38100;
          align-items: center;
        }
      }

      .text {
        padding: 0 24px;
        margin-top: 15px;
        text-indent: 2em;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #a38100;
        height: 80px;
        overflow: auto;

        .text-all {
          height: 160px;
        }
      }

      .icon-info {
        display: flex;
        justify-content: space-between;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        color: #a38100;
        margin-top: 8px;

        .info-addr {
          border-right: 1px solid #a38100;
        }

        a {
          font-style: normal;
          // font-weight: 600;
          font-size: 14px;
          text-align: center;
          color: #a38100;
        }

        > div,
        a {
          width: 50%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 15px;
            height: auto;
            margin-right: 5px;
          }
        }
      }
    }

    .tabs {
      margin: 0 auto;
      position: absolute;
      z-index: 5;
      width: 338px;
      height: 50px;
      left: 23px;
      top: 180px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      overflow-x: scroll;

      // overflow: hidden;
      .tabItem {
        flex-shrink: 0;
        width: 44px;
        height: 28px;
        border-radius: 4px;
        background: transparent;
        text-align: center;
        line-height: 28px;
      }

      .active {
        background: #fff;
      }
    }

    .foodList {
      margin: 0 auto;
      position: absolute;
      z-index: 5;
      width: 338px;
      left: 50%;
      transform: translateX(-50%);
      top: 220px;
      background: #fff5d2;
      border-radius: 8px;

      .img1,
      .img2 {
        position: absolute;
        z-index: 10;
      }

      .img1 {
        top: -12px;
        left: 60px;
      }

      .img2 {
        top: -12px;
        right: 60px;
      }

      .foodList-bg {
        width: 100%;
        height: calc(100vh - 180px - 85px);
        overflow: hidden;
        overflow-y: scroll;
        position: absolute;
        z-index: 2;
        background: #ffffff;
        border: 3px solid #ffe582;
        border-radius: 8px;

        top: 7px;

        > div {
          width: 100%;
          overflow: hidden;

          img {
            width: 100%;
            height: auto;
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  .history {
    // width: 100px;
    height: 44px;
    border-radius: 25px 0 0 25px;
    background: #ffffff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    // top: 580px;
    bottom: 80px;
    right: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #333333;

    img {
      margin: 0 5px 0 14px;
    }
  }

  .flex {
    position: fixed;
    z-index: 1;
  }

  .flexBg1 {
    top: 0;
    right: 0;
  }

  .flexBg2 {
    top: 145px;
    left: 0;
  }

  .flexBg3 {
    top: 234px;
    right: 0;
  }

  .flexBg4 {
    top: 320px;
    left: 0;
  }

  .flexBg5 {
    top: 460px;
    right: 0;
  }

  .flexBg6 {
    top: 600px;
    left: 0;
  }
}

// ::v-deep .van-tabs__nav {
//   background: transparent !important;
// }
// ::v-deep .van-tabs__wrap--scrollable .van-tab {
//   padding-left: 0;
// }
// ::v-deep .van-tabs__nav--line.van-tabs__nav--complete {
//   padding-left: 0;
// }
.menubg {
  background-image: url('../../assets/images/大荤.png');
  background-size: 100% 100%;
}

.menubg1 {
  background-image: url('../../assets/images/小荤.png');
  background-size: 100% 100%;
}

.menubg2 {
  background-image: url('../../assets/images/素菜.png');
  background-size: 100% 100%;
}

.scroll {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  .scrollItemBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 5px;
    font-size: 14px;
  }

  .scrollItem {
    width: 80px;
    height: 70px;
    border-radius: 8px;
    overflow: hidden;

    flex-shrink: 0;
  }
}

.scroll::-webkit-scrollbar {
  display: none;
}

.ellipsis {
  text-align: center;
  width: 85px;
  max-width: 85px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag {
  width: 38px;
  height: 16px;
  border-radius: 2px;
  background: #f58506;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
